import type {
  GenerateOtpPayload,
  OtpValidateCredentials,
  PasswordLoginCredentials,
  PhoneCredentials,
} from "./types";

export function buildGenerateOtpPayload(
  phone: PhoneCredentials,
  captchaToken: string,
  admissionNumber?: string
): GenerateOtpPayload {
  return {
    dialCode: phone.dialCode,
    number: phone.number,
    captcha_token: captchaToken,
    ...(admissionNumber ? { admissionNumber } : {}),
  };
}

export function buildPasswordLoginPayload(
  phone: string,
  password: string,
  countryCode: string,
  admissionNumber?: string
): PasswordLoginCredentials {
  return {
    phone,
    password,
    countryCode,
    ...(admissionNumber ? { admissionNumber } : {}),
  };
}

export function buildOtpValidatePayload(
  phone: string,
  otp: string,
  countryCode: string,
  admissionNumber?: string
): OtpValidateCredentials {
  return {
    phone,
    otp,
    countryCode,
    ...(admissionNumber ? { admissionNumber } : {}),
  };
}
